<template>
	<div class="index">
		<!-- banner图 -->
		<div class="newsCenterBanenr">
			<img src="../../assets/xiangning/ztpx_banner.png">
		</div>
		<div class="djxxhome_wrap">
			
			<!-- 搜索框部分 -->
			<div class="search">
				<!-- 输入框 -->
				<div class="search_item">
					<input v-model="getdata.keys" type="text" placeholder="请输入要查询的关键字">
					<!-- 右侧点击按钮 -->
					<div class="search_item_buttom"  @click="getdataList()">
						<div class="search_item_buttom_icon">
							<img src="../../assets/xiangning/djxx/zjzt_search.png" alt="">
						</div>
						<div class="search_text">
							搜索
						</div>
					</div>
					<div class="bottom_keys">
						<span @click="getKeys('二十大')">二十大</span>
						<span @click="getKeys('百年党史')">百年党史</span>
						<span @click="getKeys('学习讲话')">学习讲话</span>
						<span @click="getKeys('两会精神')">两会精神</span>
						<span @click="getKeys('习近平新思想')">习近平新思想</span>
					</div>
				</div>
			</div>
			<!-- 资源类别分类 -->
			<div class="select_school">
				<div class="select_school_left">
					资源类别:
				</div>
				<div class="select_school_right">
					
					<div v-for="item in DyClass" :key="item.id" @click="changeFirst(item.id)"
						class="select_school_right_item" :style="{
							backgroundColor: getdata.type == item.id ? '#F5E5E5' : '',
							color: getdata.type == item.id ? '#CB272B' : '',
							fontWeight: getdata.type == item.id ? '800' : ''
						}">{{ item.type }}
					</div>
				</div>

			</div>
			<!-- 专题筛选 -->
			<div class="select_profession" v-if="getdata.type == '' || getdata.type == 1">
				<div class="select_profession_left">
					专题筛选:
				</div>
				<div class="select_profession_right" id="btn">
					<div @click="changeDySecond('')" :style="{
						backgroundColor: getdata.class_id == '' ? '#F9E9E9' : '',
						color: getdata.class_id == '' ? '#CB272B' : '',
						fontWeight: getdata.class_id == '' ? '800' : ''
					}" class="select_profession_right_item">全部</div>
					<div @click="changeDySecond(item.class_id)" v-for="item in DyClassSecond" :key="item.class_id" :style="{
						backgroundColor: getdata.class_id == item.class_id ? '#F9E9E9' : '',
						color: getdata.class_id == item.class_id ? '#CB272B' : '',
						fontWeight: getdata.class_id == item.class_id ? '800' : ''
					}" class="select_profession_right_item">{{ item.title }}</div>

				</div>
				<div class="btn" @click="dianjiBtn">
					<span class="first_span">{{ btn }}</span>
					<span v-if="btn == '展开'">
						<img src="../../assets/xiangning/dowm_icon.png" alt="">
					</span>
					<span v-if="btn == '收起'">
						<img src="../../assets/xiangning/up_icon.png" alt="">
					</span>
				</div>
			</div>
			<!-- 政策解读列表 -->
			<div class="dwgk_content" v-if="dataList.length > 0&getdata.type==3">
						<!-- 内容列表 -->
						<div @click="goTzggDetail(item.id,'zcjd')" class="dwgk_content_item" v-for="item in dataList">
							<!-- 左侧时间 -->
							<div class="dwgk_content_item_left_time">
								<div class="time_detail" 	v-if="$route.query.type=='dwgk'">
								<div class="time_detail_top">{{ item.day.substring(8, 10) }}</div>
								<div class="time_detail_bottom">{{ item.day.substring(0, 7) }}</div>
							</div>
							<div class="time_detail" v-else>
								<div class="time_detail_top">{{ item.pub_time.substring(8, 10) }}</div>
								<div class="time_detail_bottom">{{ item.pub_time.substring(0, 7) }}</div>
							</div>
						
							</div>
							<!-- 右侧内容 -->
							<div  class="dwgk_content_item_right">
								<div class="dwgk_content_item_right_toptitle">{{ item.title }}
								</div>
								<div class="dwgk_content_item_right_center" v-html="item.content">
								</div>
							
						</div>
						</div>
            </div>
			<!-- 视频列表 -->
			<div class="dataList" v-if="dataList.length > 0&getdata.type!=3">
				<!-- 遍历列表循环 -->
				<div class="dataList_item" v-for="item in dataList" :key="item.id" @click="goSpeaial(item)">
					<div class="dataList_item_top_img">
						<img  :src="item.sz_img" alt="">
					</div>
					<div class="dataList_item_bottom">
						<!-- 上方标题 -->
						<div class="dataList_item_bottom_top_title">{{ item.title }}
						</div>
					</div>
				</div>
			</div>
			
			<!-- 下方分页器 -->
			<Page v-if="dataList.length > 0" :total="total" :per_page="per_page" :pageSize="[20]"
				@handleCurrentChange="handleCurrentChange">
			</Page>
			<!-- 资源为空时显示 -->
			<div v-if="dataList.length == 0" class="no_pxrw">
				<img src="../../assets/xiangning/ztpx/no_pxrw.png" alt="">
			</div>

			<div style="height: 40px;" class="bottom"></div>
		</div>

	</div>
</template>
<script>
import Swiper from 'swiper';
import { ztpx, news } from '@/axios';
import Page from '@/components/page.vue'
export default {
	data() {
		return {
			// 总数据条数
			total: 100,
			// 当前页码
			per_page: 1,
			input: '',
			getdata: {
				type: 1,
				class_id: '',
				keys:this.$route.query.keys,
				page: 1,
			},
			dataList: [],
			DyClass: [
				{ id: 1, type: '党建学习' },
				{ id: 2, type: '红色全景' },
				{ id: 3, type: '政策解读' },
			],
			DyClassSecond: [
			],
		
			btn: '展开'
		}
	},
	components: { Page },
	methods: {
			// 跳转至通知公告详情
			goTzggDetail(id,type){
               this.$router.push({
				path:'/tzgg_detail',
				query:{
					id:id,
					type:type
				}
			   })
			},
		// 改变一级分类
		changeFirst(data) {
			let that = this
			that.getdata.type = data
			that.getdata.class_id = ''
			this.getdata.page = 1
			this.getdataList()


		},
		// 改变二级分类
		changeDySecond(id) {
			let that = this
			that.getdata.class_id = id
			this.getdata.page = 1
			this.getdataList()
		},
		// 改变三级分类
		changeThree(data) {
			let that = this
			that.getdata.bsid = data
			this.getdata.page = 1
			this.getdataList()
		},
		getTitleList() {
			let that = this
			news.djxxClass().then((res) => {
				if (res.code == 200) {
					that.DyClassSecond = res.data
				}
			})
		},
		// 点击展开按钮
		dianjiBtn() {
			var that = this;
			if (that.btn == "展开") {
				that.btn = "收起"
				let ClickBtn = document.getElementById('btn')

				ClickBtn.style.height = 'auto'


			} else {
				that.btn = "展开"
				let ClickBtn = document.getElementById('btn')
				ClickBtn.style.height = '60px'
			}
		},
		//   分页器页码发生变化
		handleCurrentChange(val) {
			this.getdata.page = val
			this.getdataList()
		},
		goHome() {
			this.$router.push({
				path: '/home'
			})
		},
		changeType(val) {
			this.getdata.type = val
			this.getdata.page = 1
			this.getdataList()

		},
		// 点击关键字
		getKeys(val) {
			this.getdata.keys = val
		},
		// 专题
		goSpeaial(item) {
			let id = 0
			let that = this
			if (that.getdata.type == 1) {
				this.$router.push({
					path: '/djxxResouce2',
					query: {
						id: item.id,
						two_id: item.two_id,
						one_id: item.one_id,
						flag: item.flag,
						type:'search'
					}
				})
			} else if (that.getdata.type == 2) {
				window.open(item.ment_url)
			}
		},
		getdataList() {
			let that = this
			ztpx.searchDataList(that.getdata).then((res) => {
				if (res.code == 200) {
					that.total = Number(res.data.count)
					that.dataList = res.data.pagedata
				}
			})
		}
	},
	mounted() {
		this.getTitleList()
		this.getdataList()

	},
	created() {
		this.$emit("highLight", 0, "", "", "");
	}
}
</script>

<style lang="scss" scoped>
@import '@/common/index.scss';

.index {
	width: 100%;

	.newsCenterBanenr {
		position: relative;
		width: 100%;

		img {
			width: 100%;
			height: auto;
		}
	}

	div {
		box-sizing: border-box;
	}

	.djxxhome_wrap {
		width: $indexWidth;
		margin: auto;
		min-width: 1200px;
		position: relative;

		/* 搜索框部分 */
		.search {
			position: absolute;
			top: -127px;
			width: 100%;
			height: 107px;
			/* background-color: skyblue; */
			display: flex;
			justify-content: center;

			.search_item {
				height: 77px;
				width: 600px;
				position: relative;
				display: flex;
				flex-direction: column;
				justify-content: space-between;
				align-items: center;

				/* background-color: pink; */
				input {
					display: block;
					background-color: #FCEAE4;
					background: rgba(255, 255, 255, 0.8);
					border-radius: 304px;
					height: 40px;
					width: 100%;
					box-sizing: border-box;
					border: 1px solid #FFFFFF;
					font-family: PingFangSC-Regular;
					font-size: 12px;
					font-weight: normal;
					letter-spacing: 0.1em;
					padding-left: 20px;
					color: #9E9E9E;
					outline: none;
				}

				.search_item_buttom {
					display: flex;
					align-items: center;
					justify-content: center;
					position: absolute;
					right: 1px;
					top: 1px;
					height: 38px;
					width: 120px;
					background-color: #EE632B;
					border-radius: 0px 20px 20px 0px;

					.search_item_buttom_icon {
						margin-right: 12px;
						width: 24px;
						height: 20px;

						img {
							height: 100%;
							width: 100%;
						}
					}

					.search_text {
						font-family: PingFangSC-Regular;
						font-size: 16px;
						font-weight: normal;
						letter-spacing: 0em;
						color: #FFFFFF;
						height: 32px;
						line-height: 32px;
					}

				}

				.bottom_keys {
					// width: 100%;
					height: 17px;
					/* background-color: pink; */
					width: 450px;
					display: flex;
					justify-content: space-around;
					font-family: PingFangSC-Regular;
					font-size: 12px;
					font-weight: normal;
					letter-spacing: 0em;

					color: #FFFFFF;
				}
			}
		}

		// 筛选专业及学科类型
		.select_profession {
			box-sizing: border-box;
			// height: 60px;
			line-height: 60px;
			border-bottom: 1px solid #ECEEF4;
			;
			display: flex;
			justify-content: flex-start;

			.select_profession_left {
				font-family: PingFangSC-Semibold;
				font-size: 14px;
				font-weight: 800;
				letter-spacing: 0em;
				color: #000000;
				width: 60px;
			}

			.select_profession_right {
				height: 60px;
				font-family: PingFangSC-Regular;
				font-size: 14px;
				font-weight: normal;
				letter-spacing: 0em;
				color: #666666;
				display: flex;
				justify-content: flex-start;
				align-content: flex-start;
				width: 1100px;
				flex-wrap: wrap;
				overflow: hidden;

				.select_profession_right_item {
					box-sizing: border-box;
					height: 36px;
					// width: 60px;
					padding: 0px 16px;
					margin: 12px 9px;
					line-height: 36px;
					text-align: center;
				}

			}
		}

		// 筛选资源分类
		.select_school {
			margin-top: 10px;
			box-sizing: border-box;
			height: 60px;
			line-height: 60px;
			border-bottom: 1px solid #ECEEF4;
			;
			display: flex;
			justify-content: flex-start;

			.select_school_left {
				font-family: PingFangSC-Semibold;
				font-size: 14px;
				font-weight: 800;
				letter-spacing: 0em;
				color: #000000;
			}

			.select_school_right {
				font-family: PingFangSC-Regular;
				font-size: 14px;
				font-weight: normal;
				letter-spacing: 0em;
				color: #666666;
				display: flex;
				justify-content: flex-start;

				.select_school_right_item {
					box-sizing: border-box;
					height: 36px;
					// width: 60px;
					padding: 0 16px;
					margin: 12px 9px;
					line-height: 36px;
					text-align: center;
					border-radius: 2px;
				}

			}
		}

		.select_school:nth-child(2) {
			margin-top: 0px;
		}

	   

		/* 标题部分样式 */
		.news_title {
			height: 40px;
			width: 100%;

			margin: 20px 0;
			display: flex;
			align-items: center;
			justify-content: space-between;
			padding-left: 10px;
			background: #F7F7F7;
		}

		.news_title_left {
			// width: 300px;
			height: 22px;
			border-left: 4px solid #EE632B;
			// padding-left: 20px;
			display: flex;
			justify-content: space-between;

		}

		.news_title_left_text {
			height: 22px;
			// width: 80px;
			padding: 0 20px;
			font-family: PingFangSC-Regular;
			font-size: 16px;
			font-weight: normal;
			letter-spacing: 0.1em;
			color: #999999;
		}

		/* 视频列表 */
		.dataList {
			width: 100%;
			/* height: 610px; */
			margin-top: 20px;
			display: flex;
			flex-wrap: wrap;
			justify-content: start;
			align-content: start;
			overflow: hidden;

			.dataList_item {
				width: 224px;
				height: 190px;
				border-radius: 4px;
				overflow: hidden;
				margin-bottom: 20px;
				margin-right: 20px;

				.dataList_item_top_img {
					height: 126px;
					width: 224px;
					border-radius: 4px 4px 0 0;

					img {
						width: 100%;
						height: 100%;
					}
				}

				.dataList_item_bottom {
					display: flex;
					flex-direction: column;
					justify-content: space-between;
					width: 100%;
					height: 64px;
					border: 1px solid #ECEEF4;
					padding: 10px;
					border-radius: 0 0 4px 4px;

					.dataList_item_bottom_top_title {
						width: 100%;
						height: 20px;
						overflow: hidden;
						text-overflow: ellipsis;
						white-space: nowrap;
						font-family: PingFangSC-Medium;
						font-size: 14px;
						font-weight: 800;
						line-height: 20px;
						color: #000000;
					}

					.dataList_item_bottom_top_title:hover {
						color: #C9010A;
					}

					.dataList_item_bottom_botom {
						height: 16px;
						width: 100%;
						display: flex;

						.dataList_item_bottom_botom_item {
							overflow: hidden;
							height: 100%;
							width: 74px;
							display: flex;
							justify-content: center;

							.dataList_item_bottom_botom_item_icon {
								height: 12px;
								width: 12px;
								margin-right: 2px;
								position: relative;

								img {
									position: absolute;
									top: 2.5px;
									height: 100%;
									width: 100%;
								}
							}

							.dataList_item_bottom_botom_item_content {
								font-family: PingFangSC-Regular;
								font-size: 12px;
								font-weight: normal;
								letter-spacing: 0em;

								color: #999999;
							}
						}

						.dataList_item_bottom_botom_item:nth-child(2) {
							border-left: 1px solid #ECEEF4;
							border-right: 1px solid #ECEEF4;
							;
						}

						.dataList_item_bottom_botom_item:nth-child(1) {
							display: flex;
							justify-content: start;
						}

						.dataList_item_bottom_botom_item:nth-child(3) {
							display: flex;
							justify-content: end;

							.dataList_item_bottom_botom_item_icon {
								height: 10px;
								width: 15px;
							}
						}
					}
				}


			}

			.dataList_item:nth-child(5n) {
				margin-right: 0;

			}
		}
		.dwgk_content{
				width: 100%;
				overflow: hidden;
				margin-bottom: 20px;
				.dwgk_content_item{
					height: 122px;
					width: 100%;
					/* background-color: skyblue; */
					border-bottom: 1px solid #ECEEF4;
					display: flex;
					align-items: center;
					justify-content: space-between;
					.dwgk_content_item_left_time{
						height: 82px;
						width: 96px;
						/* background-color: pink; */
						border-right:2px solid  #ECEEF4;
						.time_detail{
							height: 100%;
							width: 76px;
							.time_detail_top{
								height: 60px;
								width: 100%;
								font-family: PingFangSC-Regular;
								font-size: 64px;
								font-weight: 400;
								line-height: 60px;
								text-align: center;
								letter-spacing: 0px;
								color: #000000;
							}
							.time_detail_bottom{
								width: 100%;
								height: 22px;
								text-align: left;
								line-height: 22px;
								font-family: PingFangSC-Regular;
								font-size: 16px;
								font-weight: normal;
								text-align: center;
								letter-spacing: 0px;
								color: #000000;
							}
						
						}
					}
					
					.dwgk_content_item_right{
						height: 71px;
						width: 1102px;
						padding-left: 20px;
						/* background-color: pink; */
						display: flex;
						flex-direction: column;
						justify-content: space-between;
						.dwgk_content_item_right_toptitle{
							height: 20px;
							width: 80%;
							font-family: PingFangSC-Medium;
							font-size: 14px;
							font-weight: 800;
							letter-spacing: 0px;

							color: #000000;
							overflow: hidden;
							text-overflow: ellipsis;
							white-space: nowrap;
						}
						.dwgk_content_item_right_toptitle:hover{
							color: #EE632B;
						}
						.dwgk_content_item_right_center{
							font-family: PingFangSC-Regular;
							font-size: 12px;
							font-weight: normal;
							line-height: 20px;
							text-align: justify; /* 浏览器可能不支持 */
							letter-spacing: 0px;
							color: #666666;
							height: 40px;
							overflow: hidden;
							text-overflow:ellipsis; 
							display:-webkit-box;  
							-webkit-box-orient:vertical;  
							-webkit-line-clamp:2;  
						}
					}
				}
			}
		// 无视频时显示
		.no_pxrw {
			width: 392px;
			height: 250px;
			margin: 124px auto;

			img {
				width: 100%;
				height: 100%;
			}
		}



	}
}

.btn {
	font-family: PingFangSC-Regular;
	font-size: 14px;
	font-weight: normal;
	letter-spacing: 0em;
	color: #CB272B;

	.first_span {
		margin-right: 5px;
	}

	span {
		position: relative;

		img {
			position: absolute;
			top: 7px;
		}
	}
}</style>
